module.exports = __webpack_public_path__ + "bfbc89b517968a333e18bee156f115d2.svg";